export default {
    methods: {
        /*
        Used to track where the vehicle was added from in the Vehicle Added analytics event.
        Is set individually where it needs to change.
        Ex: ProductDetails.vue sets it to VehicleSelectorFrom.PDP
        */
        $_analyticsMixin_setVehicleAddedFrom(page) {
            this.$store.dispatch('activityTracking/setVehicleAddedFrom', page);
        },
    },
};
